import { render, staticRenderFns } from "./shoe-color.vue?vue&type=template&id=3c0c962a&scoped=true"
import script from "./shoe-color.vue?vue&type=script&lang=js"
export * from "./shoe-color.vue?vue&type=script&lang=js"
import style0 from "./shoe-color.vue?vue&type=style&index=0&id=3c0c962a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0c962a",
  null
  
)

export default component.exports